<template>
  <ScreenAdapter>
    <div class="set flex-column">
      <div class="set-top">
        <span class="set-top-ti">参数设置</span>
      </div>
      <div class="set-con flex-1 flex-row align-center">
        <div class="set-con-common set-con-left flex-1 flex-column" style="margin-right:16px">
            <h2 class="set-con-ti flex-row align-center">请选择医生</h2>
            <div class="con-search flex-row align-center">
                <input type="text" placeholder="请输入关键字" class="common-input" v-model="keyword" @keyup.enter="search">
                <button class="common-btn" @click="search">查询</button>
            </div>
            <div class="set-con-radio">
                <div class="set-con-radio-left" v-for="(item,index) in hospitalList" :key="index">
                  <label class="flex-row align-center"  @click="userName = item.userName;">
                    <input type="radio" name="OrgCode"  :value="item.usercode" v-model="usercode">
                    <span>{{item.userName}}</span>
                  </label>
                </div>
            </div>
        </div>
        <!-- <img src="../assets/img/you.png" alt="" class="set-con-you"> -->
        <div class="set-con-common set-con-right flex-1" style="display: none;">
            <!-- <div class="set-con-radio label_box">
                <div class="set-con-radio-left" v-for="(item,index) in typeList" :key="index">
                  <label class="flex-row align-center">
                    <input type="checkbox" name="onlinePayTip"  value="">
                    <span>{{item.title}}</span>
                  </label>
                </div>
            </div> -->
            <h2 class="set-con-ti flex-row align-center">请选择药房分类</h2>
            <div class="set-con-all flex-row align-center">
                <selectAll @selectAll="selectAll" />
                <span>全选</span>
            </div>
            <ul class="ul_box">
              <li>
                <div class="label_box flex-row flex-warp">
                    <label v-for="(item,key,index) in typeList" :key="index">
                      <input type="checkbox" name="typeList" :value="key" v-model="CashTypeArray">
                      <div>{{item}}</div>
                    </label>
                </div>
              </li>
            </ul>
             <h2 class="set-con-ti flex-row align-center">显示设置</h2>
            <ul class="ul_box">
              <li>
                <div class="label_box flex-row flex-warp">
                    <label v-for="(item,index) in showType" :key="index">
                      <input type="radio" name="typeList" :value="item.type" v-model="showTypeList">
                      <div>{{item.title}}</div>
                    </label>
                </div>
              </li>
            </ul>
        </div>
      </div>
      <div class="set-footer flex-row align-center justify-center">
          <button class="common-btn set-footer-btn"  @click="sureSet">确认设置</button>
          <!-- <button style="margin-left: 20px;" class="common-btn set-footer-btn"  @click="gonext()">药品展示</button> -->
      </div>
    </div>
  </ScreenAdapter>
</template>

<script>
import ScreenAdapter from '../components/ScreenAdapter'
import selectAll from '../components/select-all'
export default {
  components: {ScreenAdapter, selectAll},
  data () {
    return {
      keyword: '', // 关键字
      hospitalList: [], // 医馆列表
      typeList: [], // 分类列表
      usercode: '', // 组织id
      userName: '', // 组织名称
      CashTypeArray: [], // 选择的分类
      showType: [
        {
          type: 3,
          title: '待配药和待取药'
        },
        {
          type: 2,
          title: '待取药'
        }
      ],
      showTypeList: '2' // 选择的显示类别
    }
  },
  mounted () {
    //let localData = JSON.parse(this.local.getItem('params')) // 获取本地缓存中的配置信息
    /* if (localData) {
      this.keyword = localData.OrgName
      this.OrgName = localData.OrgName
      this.OrgCode = localData.OrgCode
      this.CashTypeArray = localData.CashType.split(',')
      this.showTypeList = localData.DataType
    } */
    this.initOrg()
  },
  methods: {
    // 初始化组织
    initOrg () {
      this.$http.get('/BigCallScreen/CallDoc', {
        params: {
          DoctorCode: this.keyword
        }
      }).then(data => {
        console.log(data.data.Take)
        this.hospitalList = data.data.Take || []
      })
    },
    // 搜索医馆
    search (e) {
      this.initOrg()
    },
    // 确认配置
    sureSet () {
      // eslint-disable-next-line no-undef
      if (!this.usercode) {
        alert('请选择配置医生')
        return false
      }
      /* if (this.CashTypeArray.length === 0) {
        alert('请选择药房分类')
        return false
      }
      if (!this.showTypeList) {
        alert('请选择显示方式')
        return false
      } */
      // let CashType = this.CashTypeArray.toString()
      let params = {
        OrgCode: this.usercode,
        OrgName: this.userName
      }
      console.log(params)
      this.local.setItem('params', JSON.stringify(params))
      this.$router.push({
        name: 'doctorDisplayAll',
        query: params
      })
    },
    // 全选
    selectAll (status) {
      console.log(status)
      if (status) {
        this.CashTypeArray = Object.keys(this.typeList)
      } else {
        this.CashTypeArray = []
      }
    }
    /* gonext () {
      this.$router.push({
        name: 'medicineShow'
      })
    } */
  }
}
</script>

<style>
.set{
  width: 100%;
  height: 100%;
  background: #570404;
  overflow: hidden;
}
.set{

}
.set-top{
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.set-top .set-top-ti{
  font-size: 34px;
  color: #ffffff;
}
.set-con{
  box-sizing: border-box;
  padding: 20px;
}
.set-con-ti{
  margin-bottom: 16px;
}
.set-con-all{
  margin-bottom: 14px;
  padding-left: 20px;
}
.set-con-all span{
  display: inline-block;
  margin-left: 15px;
  font-size: 28px;
}
.set-con-ti::before{
  content: '';
  display:inline-block;
  width: 6px;
  height: 25px;
  background:  #570404;
  border-radius: 5px;
  margin-right: 10px;
  margin-top: 5px;
}
.con-search button{
  font-size: 18px;
  padding: 10px 21px;
  margin-left: 16px;
  color: #ffffff;
  background: #57a3f3;
}
.set-con-radio{
  height:750px;
  overflow-y: scroll;
  margin-top: 16px;
}
.set-con-radio-left{
  margin-bottom: 20px;
}
.set-con-radio-left input{
  width: 36px;
  height: 36px;
  margin-right: 5px;
  border: 2px solid #D3CFC8;
  border-radius: 50%;
  position: relative;
}
/* .set-con-radio-left input::after{
  content: "";
  display: block;
  width: 4px;
  height: 9px;
  position: absolute;
  top: .5px;
  left: 4px;
  border: solid 2px red;
  border-left: none;
  border-top: none;
  transform: rotate(45deg);
} */
.set-con-radio-left span{
  display: inline-block;
  font-size: 28px;
  margin-left: 10px;
}
.set-con .set-con-common{
  box-sizing: border-box;
  background: #ffffff;
  height: 100%;
  border-radius: 16px;
  padding: 16px;
}
.set-con .set-con-you{
  height: 100px;
  margin: 0 30px;
}
.set-footer .set-footer-btn{
  font-size: 26px;
  margin-bottom: 16px;
  width: 240px;
  height: 60px;
  color: #333333;
}
.ul_box {
	margin:0 auto;
  padding: 0;
	list-style: none;
  margin-left: 12px;
}
.ul_box>li {
	padding:10px 10px 0 10px;
	overflow:hidden;
  border-bottom:#e5e5e5 solid 1px;
  font-size: 28px;
}
.ul_box>li:last-child {
	border-bottom:none;
}
.label_box>label {
	display:block;
	margin:0 42px 30px 0;
	position:relative;
	overflow:hidden;
}
.label_box>label>input {
	position:absolute;
	top:0;
	left:-20px;
}
.label_box>label>div {
	text-align:center;
	border: #999999 solid 1px;
	height:60px;
  line-height:60px;
  padding: 0 20px;
	color:#666666;
	user-select:none;
	overflow:hidden;
	position:relative;
}
.label_box>label>input:checked + div {
	border:#d51917 solid 1px;
	color:#d51917;
}
.label_box>label>input:checked + div:after {
	content:'';
	display:block;
	width:45px;
	height:35px;
	background-color:#d51917;
	transform:skewY(-45deg);
	position:absolute;
	bottom:-25px;
	right:0;
	z-index:1;
}
.label_box>label>input:checked + div:before {
	content:'';
	display:block;
	width:6px;
	height:15px;
	border-right:#ffffff solid 2px;
	border-bottom:#ffffff solid 2px;
	transform:rotate(35deg);
	position:absolute;
	bottom:4px;
	right:6px;
	z-index:2;
}
</style>



// WEBPACK FOOTER //
// src/pages/doctorSet.vue